module.exports = __webpack_public_path__ + "img/common-list.69ed9e4d.png";